import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

const MaximumPhotoTypes = ({
  trialDetails,
  setTrialDetails,
  handleBasicInfoUpdate,
  maximumPhototypes,
  setMaximumPhototypes,
}) => {
  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const role = user_data.role;
  const [isValueUpdated, setIsValueUpdated] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setTrialDetails((prevDetails) => ({
      ...prevDetails,
      maximum_photo_types: value,
    }));
    setMaximumPhototypes(true);
    setIsValueUpdated(true);
  };

  const handleSave = () => {
    handleBasicInfoUpdate();
    setIsValueUpdated(false);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 2,
        }}
      >
        <TextField
          label="Maximum Photo Types"
          size="small"
          type="number"
          name="photo_types"
          value={trialDetails.maximum_photo_types || ""}
          onChange={handleChange}
          sx={{ width: { xs: "100%", md: "50%" } }}
        />

        {role !== "Investigator" && role !== "Inv_coordinator" && role !== "Reviewer" && (
          <Button
            variant="contained"
            size="small"
            id="max-photos-settings"
            onClick={handleSave}
            disabled={!maximumPhototypes || !isValueUpdated}
          >
            Save
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default MaximumPhotoTypes;
